import { ref } from 'vue';

export const requestNotificationPermission = () => window.Notification?.requestPermission?.();

import { Howl } from 'howler';

let notificationSound = null;
let audioReady = ref(false);

// 初始化音頻
async function loadAudio() {
  try {
    notificationSound = new Howl({
      src: ['/mp3/dingdong.mp3'], // 支持多格式備選 ['dingdong.mp3', 'dingdong.ogg']
      volume: 0.8,
      preload: true,
      onload: () => {
        audioReady.value = true;
        console.log('音頻加載完成');
      },
      onloaderror: (id, error) => {
        console.error('音頻加載失敗:', error);
      },
      onplayerror: (id, error) => {
        console.error('播放失敗:', error);
        // 嘗試自動解鎖
        notificationSound.once('unlock', () => {
          notificationSound.play();
        });
      },
    });
  } catch (e) {
    console.error('初始化音頻失敗:', e);
  }
}

// 播放通知音效
export function playNotificationSound() {
  if (!audioReady.value) {
    console.warn('音頻尚未準備好');
    return;
  }

  // 停止當前播放（防止重疊）
  notificationSound.stop();

  // 播放音效
  notificationSound.play();
}

// 初始化加載（可根據需要延遲到用户交互時）
loadAudio();

// 可選：添加用户交互解鎖
document.addEventListener(
  'click',
  () => {
    if (!audioReady.value && notificationSound) {
      // 嘗試靜音播放以解鎖音頻
      notificationSound.volume(0);
      notificationSound.play();
      notificationSound.once('play', () => {
        notificationSound.stop();
        notificationSound.volume(0.8);
      });
    }
  },
  { once: true },
);
